<div class="page-container">
  @if(pageStatus === pageStatusEnum.LOADING) {
    <app-loading [text]="loadingMessage"></app-loading>
  } @else if(pageStatus === 'complete') {
    <app-status-message
      class="page-container m-2"
      title="Pedido feito!"
      body="Assim que estiver pronto, levaremos até sua mesa."
      illustration="happyCheck"
      [footerButtonProps]="completeButtonProps"
    ></app-status-message>
  } @else if(pageStatus === 'error') {
    <app-status-message
      class="page-container m-2"
      title="Ops. Algo deu errado!"
      body="Tente novamente mais tarde."
      illustration="sad"
      [footerButtonProps]="errorButtonProps"
    ></app-status-message>
  } @else if(pageStatus === pageStatusEnum.SUCCESS) {
    <app-bar
      title="Pedido"
      [backButtonProps]="backButtonProps"
      (backButtonClick)="handleBackButtonClick()"
      [actionButtonProps]="{color: 'primary', variant: 'plain', size: 'small', label: 'Limpar'}"
      (actionButtonClick)="handleClearCart()"
    ></app-bar>

    <div class="page-content">
      <section class="page-section gap-2 border-bottom">
        <h2 class="title-large">
          Itens adicionados
        </h2>

        <div class="cart-items-container">
          @if(cart && cart.length == 0) {
            <p>
              SEM ITENS ADICIONADOS NO PEDIDO
            </p>
          } @else {
            <div class="cart-item-wrapper" *ngFor="let item of displayCart">
              <div class="cart-item-image">
                @if(item.img) {
                  <img
                    [src]="item.img"
                    [alt]="'Imagem do produto' + item.name"
                  >
                } @else {
                  <mnt-icon
                    icon="image"
                    size="44"
                    color="#4B5053"
                    [background]="['#E5E7E8', 'rounded']"
                  ></mnt-icon>
                }
                <mnt-button-icon
                  icon="pencilSimple"
                  size="tiny"
                  variant="regular"
                  color="neutral"
                  (buttonClick)="handleEditItem(item)"
                ></mnt-button-icon>
              </div>

              <div class="cart-item-info">
                <span class="label-medium-small">
                  {{ item.name }}
                </span>

                <span
                  class="cart-item-description"
                  *ngIf="item.description"
                >
                  {{ item.description }}
                </span>

                <span
                  class="label-regular-small"
                  *ngIf="item.additional_info"
                >
                  Obs: {{ item.additional_info }}
                </span>

                <ul class="unstyled-list" *ngIf="item.selectedChoices && item.selectedChoices.length > 0">
                  <li *ngFor="let choice of item.selectedChoices">
                    <span class="label-regular-tiny text-color-subtitle">
                      {{ choice.quantity || 1 }}x {{ choice.name }}
                    </span>
                  </li>
                </ul>

                <div class="d-flex align-center gap-1">
                  @if(item.choices && item.choices.length > 0 && item.promotional_price) {
                    <span class="label-regular-tiny text-color-title">
                      {{ item.promotional_price * item.qty | currency }}
                    </span>
                    <span class="label-regular-tiny text-color-subtitle text-decoration-line-through">
                      {{ item.total * item.qty | currency }}
                    </span>
                    <mnt-badge
                      color="primary"
                      size="tiny"
                      variant="regular"
                      tone="highlight"
                      [label]="item.promotional_percentage + '%'">
                    </mnt-badge>
                  } @else {
                    <span class="label-regular-tiny text-color-subtitle">
                      {{ item.total * item.qty | currency }}
                    </span>
                  }
                </div>
              </div>

              <div class="cart-item-options ml-auto">
                <mnt-field-number
                  variant="plain"
                  size="small"
                  [max]="99"
                  [min]="0"
                  [value]="item.qty"
                  (change)="handleQuantityChange(item, $event)"
                ></mnt-field-number>
              </div>
            </div>
          }
        </div>

        <div class="d-flex space-between align-center ml-auto mr-auto">
          <mnt-button
            icon-left="plus"
            label="Adicionar mais produtos"
            size="small"
            color="primary"
            variant="plain"
            (buttonClick)="handleAddMoreProducts()"
          ></mnt-button>
        </div>
      </section>

      <section class="page-section">
        <div *ngIf="cart && cart.length > 0" class="w-100 d-flex-column gap-2">
          <div class="d-flex space-between">
            <span class="label-semibold-large">Total do pedido</span>
            <span class="label-semibold-large">{{ cartTotal | currency }}</span>
          </div>
        </div>
      </section>
    </div>

    <div class="page-footer d-column gap-3 mt-auto">
      @if(!submittingCart) {
        <mnt-button
          class="w-100"
          variant="emphasis"
          color="primary"
          size="large"
          [label]="!isUserLoggedIn ? 'Próximo' : 'Fazer pedido'"
          full-width
          (buttonClick)="handleContinue()"
        ></mnt-button>
      } @else {
        <mnt-button
          label="Enviando pedido..."
          class="w-100"
          variant="emphasis"
          icon-left="loading"
          animation="spin"
          color="primary"
          size="large"
          disabled
          full-width
        ></mnt-button>
      }
    </div>
  }
</div>
